import { useNavigate } from "react-router";
import { useAppSelector } from "@/utils/hooks/useRedux";

export const useLastUrlWasPage = () => {
  const lastUrlWasPage = useAppSelector((state) => state.dashboard.lastUrlWasPage);
  const domNavigate = useNavigate();

  return {
    last: lastUrlWasPage,
    navigateToLast: () => {
      if (lastUrlWasPage) {
        domNavigate(lastUrlWasPage);
      } else {
        domNavigate(-1);
      }
    },
  };
};
